export default "__VITE_ASSET__Bex6556l__"